import { combineReducers, configureStore } from '@reduxjs/toolkit';

import bookingSlice from './slice/bookingSlice';
import hotelConfigSlice from './slice/hotelConfigSlice';
import themeSlice from './slice/themeSlice';
import appConfigSlice from './slice/appConfigSlice';

const reducer = combineReducers({
  booking: bookingSlice,
  hotelConfig: hotelConfigSlice,
  theme: themeSlice,
  appConfig: appConfigSlice,
});

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
